import Vue from 'vue'
import App from './App.vue'
import "@/assets/css/tailwind.css"
import "@/helpers/filters";

import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

// Or only as a filter
import { VueMaskFilter } from 'v-mask'
Vue.filter('VMask', VueMaskFilter)

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

Vue.use(VueAxios, axios);